import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { API_MAP } from 'app/core/helpers/api.map';
import { map } from 'rxjs';
import { HospitalService } from './hospital.service';
import { removeQueryParams } from 'app/shared/components/select/helper-functions';

export const HospitalResolver: ResolveFn<boolean> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(HospitalService)
    .get(API_MAP.hospital + removeQueryParams(state.url).substring(1))
    .pipe(map(() => true));
};
